import { PageManagerModule } from "@/store/modules/PageManager.module";
import { Machine } from "xstate";
const PageManagerMachine = Machine({
    id: "PageManagerMachine",
    context: {},
    initial: "idle",
    states: {
        idle: {
            always: [{ target: "gettingPages" }],
        },
        gettingPages: {
            invoke: {
                id: "gettingPages",
                src: (ctx, event) => {
                    return PageManagerModule.GetPageManager();
                },
                onDone: { target: "loadedPages" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedPages: {
            on: {
                ADDING_PAGE: { target: "addingPage" },
                EDIT_PAGE: { target: "editingPage" },
                LOAD_PAGEELEMENTS: { target: "gettingPageElements" },
                DELETE_PAGE: { target: "deletePage" },
            },
        },
        addingPage: {
            tags: "showAddPageUI",
            on: {
                SAVE_PAGE: { target: "savingPage" },
                CANCEL_ADDING_PAGE: { target: "loadedPages" },
            },
        },
        savingPage: {
            tags: "showAddPageUI",
            invoke: {
                id: "savingPage",
                src: (ctx, evt) => PageManagerModule.AddPage(evt.newPage),
                onDone: { target: "gettingPages", actions: ["showSuccessMessage"] },
                onError: { target: "gettingPages" },
            },
        },
        editingPage: {
            tags: "showEditPageUI",
            on: {
                UPDATE_PAGE: { target: "updatePage" },
                CANCEL_EDITING__PAGE: { target: "loadedPages" },
            },
        },
        updatePage: {
            tags: "showEditPageUI",
            invoke: {
                id: "updatePage",
                src: (ctx, evt) => PageManagerModule.UpdatePage(evt.updatePage),
                onDone: { target: "gettingPages", actions: ["showSuccessMessage"] },
                onError: { target: "gettingPages" },
            },
        },
        deletePage: {
            tags: "showPageDeleteUI",
            on: {
                DELETING_PAGE: { target: "deletingPage" },
                CANCEL_DELETE_PAGE: { target: "loadedPages" }
            },
        },
        deletingPage: {
            tags: "showPageDeleteUI",
            invoke: {
                id: "deletingPageItem",
                src: (ctx, evt) => {
                    return PageManagerModule.DeletePage(evt.pageId);
                },
                onDone: { target: "gettingPages", actions: ["showSuccessMessage"] },
                onError: { target: "gettingPages" },
            },
        },
        gettingPageElements: {
            tags: "showPageElementsUI",
            invoke: {
                id: "gettingPageElements",
                src: (ctx, event) => {
                    return PageManagerModule.GetPageElements(event.pageId);
                },
                onDone: { target: "loadedPageElements" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedPageElements: {
            tags: "showPageElementsUI",
            initial: "listing",
            on: {
                ADDING_PAGE_ELEMENT: { target: ".addPageElement" },
                EDITING_PAGE_ELEMENT: { target: ".editPageElement" },
                CLOSE_PAGEELEMENT: { target: "loadedPages" },
                LOAD_PAGEELEMENTS: { target: "gettingPageElements" },
                DELETE_PAGE_ELEMENT: { target: ".deletePageElement" },
            },
            states: {
                listing: {},
                addPageElement: {
                    tags: "showAddPageElementUI",
                    on: {
                        SAVING_PAGE_ELEMENT: { target: "savePageElement" },
                        CANCEL_PAGE_ELEMENT: { target: "listing" },
                    },
                },
                savePageElement: {
                    tags: "showAddPageElementUI",
                    invoke: {
                        id: "savingPageItem",
                        src: (ctx, evt) => PageManagerModule.AddPageElements(evt.newPageElement),
                        onDone: { target: "#PageManagerMachine.loadedPageElements", actions: ["showSuccessMessage"] },
                        onError: { target: "addPageElement" },
                    },
                },
                editPageElement: {
                    tags: "showPageElementEditorUI",
                    on: {
                        UPDATE_PAGE_ELEMENT: { target: "updatePageElement" },
                        CANCEL_EDIT_PAGE_ELEMENT: { target: "listing" },
                    },
                },
                updatePageElement: {
                    tags: "showPageElementEditorUI",
                    invoke: {
                        id: "updatingListItem",
                        src: (ctx, evt) => PageManagerModule.UpdatePageElement(evt.updatePageElement),
                        onDone: { target: "#PageManagerMachine.loadedPageElements", actions: ["showSuccessMessage"] },
                        onError: { target: "editPageElement" },
                    },
                },
                deletePageElement: {
                    tags: "showPageElementDeleteUI",
                    on: {
                        DELETING_PAGE_ELEMENT: { target: "deletingPageElement" },
                        CANCEL_DELETE_PAGE_ELEMENT: { target: "listing" },
                    },
                },
                deletingPageElement: {
                    tags: "showPageElementDeleteUI",
                    invoke: {
                        id: "deletingPageItem",
                        src: (ctx, evt) => {
                            return PageManagerModule.DeletePageElementById(evt.pageElementId);
                        },
                        onDone: { target: "#PageManagerMachine.loadedPageElements", actions: ["showSuccessMessage"] },
                        onError: { target: "deletePageElement" },
                    },
                },
            },
        },
        serviceUnavailable: { type: "final" },
    },
}, {
    actions: {},
    guards: {},
    activities: {},
    services: {},
});
export default PageManagerMachine;
